export default {
  setModals: (state, { type, data }) => {
    const updatedModals = { ...state.modals }

    updatedModals[type] = data

    state.modals = updatedModals
  }
}
